import { Reveal } from "@/components/Reveal";

const IMG_ENGINEER =
    "https://images.unsplash.com/photo-1672748341520-6a839e6c05bb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwyfHxlbmdpbmVlciUyMHBvcnRyYWl0JTIwaW5kdXN0cmlhbHxlbnwwfHx8fDE3ODU1MjgwOTN8MA&ixlib=rb-4.1.0&q=85";

const chapters = [
    {
        n: "01",
        title: "Offshore, exclusively.",
        body: "We do not service commercial buildings, hospitals or data centres. Every technician, every procedure and every spare part is dedicated to marine and offshore assets. That focus is our margin of safety.",
    },
    {
        n: "02",
        title: "Pressurization is life-safety.",
        body: "In hazardous zones, HVAC is not comfort — it is the barrier between breathable air and an explosive atmosphere. We treat pressurization as a life-safety system, tested and logged on every visit.",
    },
    {
        n: "03",
        title: "Certified for the blast zone.",
        body: "ATEX / IECEx competent crews, rope-access qualified, offshore survival trained. We arrive ready to work the deck the moment the helicopter lands — no ramp-up, no excuses.",
    },
];

export default function Manifesto() {
    return (
        <section id="manifesto" data-testid="manifesto-section" className="bg-surface py-24 lg:py-32 border-y border-border">
            <div className="mx-auto max-w-[1400px] px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
                {/* Sticky image */}
                <div className="lg:col-span-5">
                    <div className="lg:sticky lg:top-28">
                        <Reveal>
                            <span className="font-mono-tech text-xs uppercase tracking-[0.3em] text-safety">
                                / Doctrine
                            </span>
                            <h2 className="mt-4 mb-8 font-heading font-black tracking-tighter text-4xl sm:text-5xl leading-[0.9]">
                                How we keep crews alive.
                            </h2>
                            <div className="clip-plate overflow-hidden border border-border">
                                <img
                                    src={IMG_ENGINEER}
                                    alt="Offshore engineer in safety gear"
                                    className="w-full h-[420px] object-cover"
                                />
                            </div>
                        </Reveal>
                    </div>
                </div>

                {/* Chapters */}
                <div className="lg:col-span-7 flex flex-col justify-center">
                    {chapters.map((c, i) => (
                        <Reveal
                            key={c.n}
                            delay={i * 0.05}
                            className="grid grid-cols-12 gap-4 py-10 border-b border-border last:border-b-0"
                        >
                            <span className="col-span-3 lg:col-span-2 font-mono-tech text-safety text-lg">
                                {c.n}
                            </span>
                            <div className="col-span-9 lg:col-span-10">
                                <h3 className="font-heading font-bold text-2xl lg:text-3xl tracking-tight mb-3">
                                    {c.title}
                                </h3>
                                <p className="text-steel leading-relaxed max-w-xl">{c.body}</p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
